import { render } from "./boolean-cell.vue?vue&type=template&id=c47d1c72&ts=true"
import script from "./boolean-cell.ts?vue&type=script&lang=ts"
export * from "./boolean-cell.ts?vue&type=script&lang=ts"

import "./boolean-cell.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__